import { render, staticRenderFns } from "./EditCourseModal.vue?vue&type=template&id=0d71dce0&scoped=true&"
import script from "./EditCourseModal.vue?vue&type=script&lang=js&"
export * from "./EditCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71dce0",
  null
  
)

export default component.exports